import { atom, selector } from "recoil";
import { getCustomerSettings } from "../CustomerSettings";

const FlightPathModeState = atom({
    key: 'FlightPathModeState',
    default: selector({
        key: 'FlightPathModeStateSelector',
        get: () => {
            return getCustomerSettings('csConfig.flightPathMode');
        }
    })
});

export default FlightPathModeState;